// App.tsx
import React, { useEffect } from 'react';
import './App.css';
import Home from './views/Home';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';

function HtmlLanguageSync({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage(); // 'es' | 'en'
  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute('lang', language || 'en');   // <- se actualiza al vuelo
    html.setAttribute('translate', 'no');          // redundante pero inofensivo
  }, [language]);
  return <>{children}</>;
}

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <HtmlLanguageSync>
          <Home />
        </HtmlLanguageSync>
      </LanguageProvider>
    </div>
  );
}
